import { NgIf, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

export interface BannerIconDetails {
  iconPath?: string;
  title?: string;
  description: string;
};

@Component({
  selector: 'app-banner-icon',
  styleUrls: ['banner-icon.component.scss'],
  templateUrl: 'banner-icon.component.html',
  standalone: true,
  imports: [NgStyle, NgIf]
})
export class BannerIconComponent {
  @Input() backgroundImageUrl: string;
  @Input() title: string;
  @Input() bigTitle: boolean;
  @Input() description: string;
  @Input() color: 'white' | 'gray' = 'white';
}
